import { formatDuration, intervalToDuration } from "date-fns";
import { Availability } from "../types/availability";
import { Slots, TimeSlot } from "../types/slots";

export const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const formattedDuration = (minutes: number) => {
  const duration = intervalToDuration({ start: 0, end: minutes * 60 * 1000 });
  return formatDuration(duration, { format: ["hours", "minutes"] });
};

export const convertToMinutes = (duration: any | number) => {
  if (typeof duration == "number") return duration;

  if (typeof duration === "string") {
    if (duration.endsWith("h")) {
      return parseFloat(duration) * 60;
    }
    if (duration.endsWith("m")) {
      return parseFloat(duration);
    }
  }
  if (typeof duration === "object" && duration?.value != null) {
    if (duration.type === "hours") {
      return duration.value * 60;
    } else return duration.value;
  }
  return 0;
};

export const getFirstAvailableDate = (availability: Availability) => {
  if (!availability?.slots) return;
  const first = availability.slots.find((x: Slots) =>
    x.hours.some((y: TimeSlot) => y.available > 0)
  );
  return first ? first.date : undefined;
};

export const formatPrice = (amount: number, currency: string) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
  }).format(amount);
};

export const isValidHttpUrl = (string: string) => {
  try {
    const url = new URL(string);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
};

const truncateString = (str: string | null, maxLength = 512) => {
  return str && str.length > maxLength ? str.slice(0, maxLength) : str;
};

export const extractUTMParameters = (params: any) => {
  const utmParameters: any = {};
  [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "gclid",
  ].forEach((key) => {
    if (params[key]) {
      utmParameters[key] = truncateString(params[key]);
    }
  });
  return utmParameters;
};

export const getInitial = (name: string | undefined) => {
  return name
    ?.split(" ")
    .map((word) => word[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
};
